import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";

const RelatedProductsMobile = ({ related }) => {
  const [loading, setLoading] = useState();

  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest(
      "GET",
      `/vehicle${related ? "?category=" + related : ""}`,
      {},
      {}
    ).then(({ data }) => {
      setVehicles(data.data);
    });
    setLoading(false);
  }

  if (loading) {
    return (
      <div className="w-full flex justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <div className="grid grid-cols-3 gap-1">
      {vehicles?.map((e) => (
        <Link
          to={`/${e?.url?.category?.url}/${e?.url?.brand?.name}/${e?.url?.name}`}
        >
          <img
            src={CDN_BASE_URL + e?.img}
            alt={e?.name}
            title={e?.name}
            className="rounded-[8px] w-full h-[29vw] object-cover"
          />
        </Link>
      ))}
    </div>
  );
};

export default RelatedProductsMobile;
